import { useAlertsStore } from '../stores/alerts-store';

interface AlertOptions {
  title?: string;
  confirmText?: string;
}

interface ConfirmOptions extends AlertOptions {
  cancelText?: string;
}

export function appAlert(message: string, options: AlertOptions = {}): Promise<void> {
  return new Promise((resolve) => {
    useAlertsStore.getState().openAlert({
      type: 'alert',
      title: options.title,
      message,
      confirmText: options.confirmText,
      resolver: () => resolve(),
    });
  });
}

export function appConfirm(message: string, options: ConfirmOptions = {}): Promise<boolean> {
  return new Promise((resolve) => {
    useAlertsStore.getState().openAlert({
      type: 'confirm',
      title: options.title,
      message,
      confirmText: options.confirmText,
      cancelText: options.cancelText,
      resolver: resolve,
    });
  });
}
